<template>
  <div class="resultsV2-style-segment">
    <div class="resultsV2-style-description">
      <span class="resultsV2-style-description-title">Par quoi êtes-vous motivé ?</span>
      <div class="resultsV2-style-description-subtitle">
        <span>
          <span class="resultsV2-motivation-colour"> {{getStyle()}}</span>
           vous motivent plus facilement.
        </span>
      </div>
      <div class="resultsV2-style-description-text"> {{getStyleDescription()}} </div>
      <div class="resultsV2-style-keys-segment">
        <div class="resultsV2-style-keys-back resultsV2-motivation-bg-colour"><span
            class="resultsV2-style-keys-text">{{getStyleKey1()}} </span></div>
        <div class="resultsV2-style-keys-back resultsV2-motivation-bg-colour"><span
            class="resultsV2-style-keys-text">{{getStyleKey2()}} </span></div>
        <div class="resultsV2-style-keys-back resultsV2-motivation-bg-colour"><span
            class="resultsV2-style-keys-text">{{getStyleKey3()}} </span></div>
      </div>
    </div>
    <div class="resultsV2-style-graph-area">
      <div class="resultsV2-style-box4-vertical resultsV2-style-box4-vertical-top" :class="getSelectBGClass('Extra')">
        <span class="resultsV2-style-box4-text" :class="getSelectClass('Extra')">
          Buts extrinsèques
        </span>
      </div>
      <div class="resultsV2-style-box4-vertical" :class="getSelectBGClass('Intra')">
        <span class="resultsV2-style-box4-text" :class="getSelectClass('Intra')">
          Buts intrinsèques
        </span>
      </div>
      <div class="resultsV2-style-box4-vertical"  :class="getSelectBGClass('Values')">
        <span class="resultsV2-style-box4-text" :class="getSelectClass('Values')">
          Valeur de la tâche
        </span>
      </div>
      <div class="resultsV2-style-box4-vertical resultsV2-style-box4-vertical-bottom"  :class="getSelectBGClass('Feeling')">
        <span class="resultsV2-style-box4-text" :class="getSelectClass('Feeling')">
          Sentiment de maîtrise
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['style'],
  methods: {
    getStyle() {
      var text = "";
      switch (this.style) {
        case 'Extra':
        text = "Les buts extrinsèques";
          break;
        case 'Intra':
        text = "Les buts intrinsèques";
          break;
        case 'Values':
        text = "La valeur de la tâche";
          break;
        case 'Feeling':
        text = "Le sentiment de maîtrise";
          break;
        default:
          break;
      }
      return text;
    },
    getStyleDescription() {
      var text = "";
      switch (this.style) {
        case 'Extra':
        text = "Votre motivation professionnelle trouve une source importante dans la reconnaissance et la validation externe de vos réalisations. Cette orientation vers les récompenses tangibles et le regard des autres agit comme un puissant moteur dans votre progression. Vous êtes particulièrement sensible aux marques d'appréciation et aux retours positifs de votre environnement, qui alimentent votre désir de vous dépasser. Cette motivation extrinsèque se traduit par une attention particulière à l'impact visible de vos actions et à la manière dont elles sont perçues et valorisées dans votre contexte professionnel. Cette dynamique vous pousse à maintenir des standards élevés et à rechercher l'excellence dans vos réalisations.";
          break;
        case 'Intra':
        text = "Votre motivation émane principalement d'une source intérieure profonde, nourrie par votre passion et votre désir personnel de progression. Cette orientation intrinsèque se manifeste par un engagement authentique dans vos activités, indépendamment des récompenses externes. Vous trouvez une satisfaction particulière dans l'exploration de nouveaux horizons et le dépassement de vos propres limites. Cette motivation personnelle se traduit par une quête constante d'apprentissage et de croissance, alimentée par votre curiosité naturelle et votre désir d'accomplissement. Cette dynamique interne vous permet de maintenir un engagement durable, même face aux défis les plus complexes.";
          break;
        case 'Values':
        text = "Votre motivation est profondément ancrée dans la recherche de sens et d'impact significatif dans vos actions professionnelles. Vous accordez une importance particulière à la portée et à l'utilité de vos contributions, cherchant constamment à comprendre comment votre travail s'inscrit dans un contexte plus large. Cette orientation vers la valeur intrinsèque des tâches se manifeste par un engagement plus fort lorsque vous percevez clairement les retombées positives de vos efforts. Votre motivation se renforce naturellement lorsque vous pouvez établir un lien direct entre vos actions et leur impact concret sur l'organisation ou les personnes concernées.";
          break;
        case 'Feeling':
        text = "Votre motivation professionnelle est fortement liée au développement continu de votre expertise et de vos compétences. Cette quête de maîtrise se manifeste par un désir constant de perfectionnement et d'amélioration dans vos domaines d'intervention. Vous tirez une satisfaction particulière de la progression de vos capacités et de l'acquisition de nouvelles compétences. Cette orientation vers l'excellence personnelle vous pousse à rechercher des défis stimulants qui vous permettent de tester et d'étendre vos limites. Le sentiment de contrôle et d'expertise qui en découle agit comme un puissant moteur dans votre développement professionnel.";
          break;
        default:
          break;
      }
      return text;
    },
    getStyleKey1() {
      var text = "";
      switch (this.style) {
        case 'Extra':
        text = "Reconnaissance ";
          break;
        case 'Intra':
        text = "Passion ";
          break;
        case 'Values':
        text = "Signification ";
          break;
        case 'Feeling':
        text = "Confiance ";
          break;
        default:
          break;
      }
      return text;
    },
    getStyleKey2() {
      var text = "";
      switch (this.style) {
        case 'Extra':
        text = "Récompense ";
          break;
        case 'Intra':
        text = "Exploration ";
          break;
        case 'Values':
        text = "Impact ";
          break;
        case 'Feeling':
        text = "Capacité ";
          break;
        default:
          break;
      }
      return text;
    },
    getStyleKey3() {
      var text = "";
      switch (this.style) {
        case 'Extra':
        text = "Validation";
          break;
        case 'Intra':
        text = "Accomplissement";
          break;
        case 'Values':
        text = "Utilité";
          break;
        case 'Feeling':
        text = "Force";
          break;
        default:
          break;
      }
      return text;
    },
    getSelectClass(style) {
      var text = "";
      if  (this.style == style) {
        text += "resultsV2-style-box4-text-selected";
      }
      return text;
    },
    getSelectBGClass(style) {
      var text = "";
      if  (this.style == style) {
        text += "resultsV2-motivation-bg-colour";
      }
      return text;
    },
  }
};
</script>

<style>
.resultsV2-motivation-colour {
  color: #B09FFF;
}

.resultsV2-motivation-bg-colour {
  background: linear-gradient(180deg, #B09FFF, #8D79F6)!important;
}
</style>